import { percentageToInches, getCoordinates } from '../helpers'
import { addSvg } from '../helpers'

function renderImage({ x, y, height, width, parent, svgNode, slide }) {
  const coordinates = getCoordinates({ x, y }, parent)
  const imagePosition = {
    x: coordinates.x,
    y: coordinates.y,
    h: percentageToInches(height / 1080, 'y'),
    w: percentageToInches(width / 1920, 'x'),
  }

  const imagePath = svgNode.properties.href

  if (imagePath.includes('http')) {
    slide.addImage({
      path: imagePath,
      ...imagePosition,
      x: imagePosition.x + imagePosition.h / 4,
      w: imagePosition.h,
    })
    return
  }

  if (imagePath.includes('base64')) {
    slide.addImage({
      data: imagePath,
      ...imagePosition,
    })
    return
  }

  if (typeof imagePath === 'string') {
    slide.addImage({
      path: `${imagePath}`,
      ...imagePosition,
    })
    return
  }

  if (imagePath === '' || imagePath === null) {
    return
  }

  const svgImageXML = imagePath.default.content
  const viewBox = imagePath.default.viewBox

  addSvg(svgImageXML, slide, viewBox, imagePosition)
}

export default renderImage
